import {SListTabs} from "shj-components";
import BuildingList from "@/pages/buildingConfig/buildingList";
import BuildingArea from "@/pages/buildingConfig/buildingArea";
import Developerlist from "@/pages/buildingConfig/estateManage/developerlist";
import {getAuth} from "@/utils/auth.ts";

const BuildingConfig = () => {

  const items = [
    {
      key: 'buildingList',
      label: '楼盘列表',
      children: <BuildingList/>,
      auth: 'buildingListTab'
    },
    {
      key: 'buildingArea',
      label: '区域列表',
      children: <BuildingArea/>,
      auth: 'buildingAreaTab'
    },
    {
      key: 'developerList',
      label: '开发商列表',
      children: <Developerlist/>,
      auth: 'developerListTab'
    },
  ]

  return <SListTabs items={items} hideExtra={true} auth={getAuth()} />
}

export default BuildingConfig